import { render, staticRenderFns } from "./ManufacturingBlock.vue?vue&type=template&id=40c4cd82"
import script from "./ManufacturingBlock.vue?vue&type=script&lang=js"
export * from "./ManufacturingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports